export default __webpack_public_path__ + "static/media/guru.fbea50bd.png";